var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"t-payment-status",attrs:{"round":"","small":"","outline":"","disabled":"","color":_vm.statusLabel.color}},[_c('span',{class:`${_vm.statusLabel.color}--text`},[_vm._v(_vm._s(_vm.statusLabel.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }